import { Link } from "react-router-dom";
import { Logo } from "../components/ui/Logo";

function Section({ n, title, children }) {
  return (
    <section className="mt-10">
      <h2 className="text-lg font-semibold tracking-tight text-[#1a4f8a] sm:text-xl">
        {n}. {title}
      </h2>
      <div className="mt-3 space-y-3 text-[15px] leading-relaxed text-slate-700 sm:text-base">{children}</div>
    </section>
  );
}

export default function DatosClinicos() {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-3xl px-6 py-10 sm:px-10 sm:py-14 lg:px-12 lg:py-16">
        <div className="flex justify-start">
          <Link
            to="/"
            className="text-sm font-medium text-slate-600 underline-offset-2 transition-colors hover:text-[#1a4f8a] hover:underline"
          >
            ← Volver
          </Link>
        </div>

        <div className="mt-8 flex justify-center">
          <Logo variant="wordmark" format="png" size="md" className="max-h-14 sm:max-h-16" />
        </div>

        <header className="mt-10 text-center">
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">Acuerdo de Datos Clínicos</h1>
          <p className="mt-2 text-sm text-slate-500 sm:text-base">Última actualización: Mayo 2026</p>
        </header>

        <div className="mt-4 border-t border-slate-200 pt-2">
          <Section n={1} title="DECLARACIÓN FUNDAMENTAL">
            <p className="rounded-lg border border-slate-200 bg-slate-50/80 px-4 py-3 italic text-slate-800">
              &ldquo;Los datos clínicos de sus pacientes le pertenecen a usted. Aurora Geriátrica es únicamente la herramienta
              tecnológica que usted utiliza para gestionarlos.&rdquo;
            </p>
          </Section>

          <Section n={2} title="COMPROMISOS DE AURORA GERIÁTRICA">
            <ul className="list-disc space-y-2 pl-5">
              <li>Solo el médico accede a sus pacientes</li>
              <li>Sin uso comercial de datos clínicos</li>
              <li>Exportación garantizada en cualquier momento</li>
              <li>Eliminación garantizada al cancelar</li>
              <li>Notificación de incidentes en 72 horas</li>
            </ul>
          </Section>

          <Section n={3} title="RESPONSABILIDADES DEL MÉDICO">
            <ul className="list-disc space-y-2 pl-5">
              <li>Obtener consentimiento apropiado de sus pacientes</li>
              <li>Usar la plataforma para fines clínicos legítimos</li>
              <li>Mantener confidencialidad de credenciales</li>
            </ul>
          </Section>

          <Section n={4} title="CONTACTO">
            <p>
              <a href="mailto:legal@aurorageriatrica.com" className="font-medium text-[#1a4f8a] underline-offset-2 hover:underline">
                legal@aurorageriatrica.com
              </a>
            </p>
            <p>Respuesta máxima: 5 días hábiles</p>
          </Section>
        </div>

        <footer className="mt-14 border-t border-slate-200 pt-8 text-center text-sm text-slate-600">
          <p className="font-medium text-slate-700">Documentos relacionados</p>
          <nav className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
            <Link to="/terminos" className="text-[#1a4f8a] underline-offset-2 hover:underline">
              Términos y Condiciones
            </Link>
            <span className="text-slate-300" aria-hidden>
              ·
            </span>
            <Link to="/privacidad" className="text-[#1a4f8a] underline-offset-2 hover:underline">
              Política de Privacidad
            </Link>
          </nav>
        </footer>
      </div>
    </div>
  );
}
